<template>
  <div class="video-content">
    <BoardSearch
      :placeholder="searchPlaceholder"
      v-model="searchKeyword"
      @search="handleSearch"
    />

    <div class="video-grid">
      <VideoCard
        v-for="video in videos"
        :key="video.id"
        :video="video"
        @click="handleVideoClick"
      />
    </div>

    <!-- 검색 결과 없음 -->
    <div v-if="!loading && videos.length === 0" class="empty-container">
      <p class="empty-text">검색 결과가 없습니다.</p>
    </div>

    <button
      class="btn-more"
      v-if="showMoreButton && !loading"
      @click="handleLoadMore"
    >
      더보기
    </button>

    <VideoModal
      :is-open="isModalOpen"
      :video="selectedVideo"
      @close="closeModal"
    />
  </div>
</template>

<script>
import BoardSearch from "./BoardSearch.vue";
import VideoCard from "./VideoCard.vue";
import VideoModal from "./VideoModal.vue";

export default {
  name: 'VideoList',
  components: {
    BoardSearch,
    VideoCard,
    VideoModal
  },
  props: {
    videos: {
      type: Array,
      required: true,
      default: () => []
    },
    searchPlaceholder: {
      type: String,
      default: '검색어를 입력하세요'
    },
    showMoreButton: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchKeyword: '',
      isModalOpen: false,
      selectedVideo: null
    };
  },
  methods: {
    handleSearch(keyword) {
      this.$emit('search', keyword);
    },
    handleVideoClick(video) {
      this.selectedVideo = video;
      this.isModalOpen = true;
      this.$emit('video-click', video);
    },
    handleLoadMore() {
      this.$emit('load-more');
    },
    closeModal() {
      this.isModalOpen = false;
      this.selectedVideo = null;
    }
  }
};
</script>

<style scoped lang="scss">
.video-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px 38px 100px;
}

.video-grid {
  margin-top: 32px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px 30px;
}

.btn-more {
  margin-top: 66px;
  font-size: 23.55px;
  line-height: 69.25px;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #222;
  width: 100%;
  cursor: pointer;
  background: white;

  &:hover {
    background: #f5f5f5;
  }
}

.empty-container {
  text-align: center;
  padding: 80px 20px;
  margin-top: 32px;
}

.empty-text {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
}
</style>